<template>
  <div>
    <div v-if="audioDataUrl === ''">
      <i class="pi pi-volume-up"></i> Audio não disponível
    </div>
    <audio v-if="audioDataUrl !== ''" :src="audioData" :id="'audio_' + messageId" controls :data-testid="'audio-message-' + messageId"></audio>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../utils/DebugLogger';

interface AudioClassElement {
  LoadAudio: (url: string, messageId: string) => Promise<void>;
  GetAudioBlob: (messageId: string) => Promise<Blob>;
}

const props = defineProps<{
  messageId?: string;
  audioDataUrl?: string;
  audioClassElement?: AudioClassElement;
}>();

const audioData = ref<string | undefined>(undefined);

onMounted(async () => {
  if (!props.audioDataUrl || !props.audioClassElement || !props.messageId) return;

  try {
    await props.audioClassElement.LoadAudio(props.audioDataUrl, props.messageId);
    const audioBlob = await props.audioClassElement.GetAudioBlob(props.messageId);
    audioData.value = URL.createObjectURL(audioBlob);
  } catch (error) {
    log('AudioMessage', 'mounted', 'Error loading audio:', error);
  }
});

onBeforeUnmount(() => {
  if (audioData.value) {
    URL.revokeObjectURL(audioData.value);
  }
});
</script>

<style scoped>
/* Add any specific styling for audio message here */
</style>
